/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import { Grid, Box } from '@mui/material';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import ModalFooter from '../../CustomModal/ModalFooter';
import _ from 'lodash';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import { toast } from 'react-hot-toast';
import Compdirection from '../../../themes/CompDirection';
import { DatePickerInput } from '../../../../components';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allEmpDocTypes: [];
  allCountires: [];
  callBackData: (data: any) => void;
  editDepDocuments: any;
  trans?: any;
}
const EditDependentsPresenter = ({
  isModalOpen,
  closeModal,
  allEmpDocTypes,
  allCountires,
  editDepDocuments,
  callBackData,
  trans,
}: ModalProps) => {
  const [document_type, setdocument_type] = useState(
    editDepDocuments?.documen_type?.type,
  );
  const [EmpDocTypeId, setEmpDocTypeId] = useState(
    editDepDocuments?.documen_type?.id,
  );
  const [countryName, setCountryName] = useState(
    editDepDocuments?.issue_country,
  );
  const [, setCountryId] = useState();
  const [issueDate, setissueDate] = useState<any>(editDepDocuments.issue_date);
  const [expiredDate, setExpiredDate] = useState<any>(
    editDepDocuments.validity_date,
  );
  const [identifierNo, setIdentifierNo] = useState(
    editDepDocuments?.identifier_number,
  );
  const [remarks, setRemarks] = useState(editDepDocuments?.remarks);
  const [removeImage, setRemoveImage] = useState<boolean>();

  const [proofAttachment, setProofAttachment] = useState('');
  const [proofAttachmentPath, setProofAttachmentPath] = useState(
    editDepDocuments?.document,
  );
  const [, setProofAttachmentName] = useState(editDepDocuments?.document);
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');
  const [newattachement, setNewAttachement] = useState(false);
  const handleSetCounty = (countryName: any) => {
    const country = _.filter(allCountires, function (c: any) {
      return c.name === countryName;
    });
    if (country.length) {
      const cnty = country[0];
      setCountryId(cnty.id);
      setCountryName(countryName);
    }
  };
  const Handledocumenttype = (document_type: any) => {
    const EmpDocTypes = _.filter(allEmpDocTypes, function (c: any) {
      return c.type === document_type;
    });
    if (EmpDocTypes.length) {
      const empdocty = EmpDocTypes[0];
      setEmpDocTypeId(empdocty.id);
      setdocument_type(document_type);
    }
  };
  const attachmentUpload = (e: any) => {
    const file: any = e.target.files[0];
    setNewAttachement(true);
    if (file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      const image_as_files: any = file;

      setProofAttachment(image_as_files);
      setProofAttachmentPath(image_as_base64);
    } else {
      setIsPDF(true);
      setPDFName(file?.name);
      setProofAttachment(file);
    }
  };
  const handleSubmit = () => {
    if (new Date(issueDate) > new Date(expiredDate)) {
      toast.error(trans('Issue date must be less than expiry date'));
    } else {
      closeModal();
      callBackData({
        docId: editDepDocuments?.id,
        documentTypeId: EmpDocTypeId,
        countryName: countryName,
        issueDate: issueDate,
        expiredDate: expiredDate,
        identifierNo: identifierNo,
        remarks: remarks,
        file: proofAttachment,
        removed: removeImage ? removeImage : null,
        newattachement: newattachement,
      });
    }
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="570px"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Edit Documents') }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '35px',
          }}
        >
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Document Type')}
              value={document_type}
              options={_.map(allEmpDocTypes, (EmpDoctype: any) => {
                return EmpDoctype.type;
              })}
              onChange={(event: any, newValue: any) => {
                Handledocumenttype(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Issue Country')}
              options={_.map(allCountires, (country: any) => {
                return country.name;
              })}
              value={countryName}
              onChange={(event: any, newValue: any) => {
                handleSetCounty(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <DatePickerInput
              label={trans('Issue Date')}
              value={issueDate}
              width="100%"
              defaultValue={editDepDocuments.issue_date}
              onChange={(newValue: any) => {
                setissueDate(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <DatePickerInput
              label={trans('Expire Date')}
              value={expiredDate}
              width="100%"
              defaultValue={editDepDocuments.validity_date}
              onChange={(newValue: any) => {
                setExpiredDate(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <CustomTextField
              type=""
              label={trans('Identifier Number')}
              placeholder={trans('Identifier Number')}
              value={identifierNo}
              onChange={(e: any) => setIdentifierNo(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <CustomTextField
              type=""
              label={trans('Remarks')}
              placeholder={trans('Remarks')}
              value={remarks}
              onChange={(e: any) => setRemarks(e.target.value)}
            />
          </Grid>

          <Grid item xs={4} style={{ marginTop: '1em', flexGrow: 1 }}>
            <DropAndSelect
              upload={attachmentUpload}
              src={proofAttachmentPath}
              isAttachmentSigned={true}
              isPDF={isPDF}
              pdfName={pdfName}
              onDelete={() => {
                setPDFName('');
                setIsPDF(false);
                setProofAttachment('');
                setProofAttachmentPath('');
                setProofAttachmentName('');
                setRemoveImage(true);
                setNewAttachement(false);
              }}
            />
          </Grid>
        </Grid>
      </Compdirection>
      <Box style={{ marginTop: '25px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};
export default EditDependentsPresenter;
